var env = process.env.RAZZLE_NODE_ENV || process.env.NODE_ENV || 'development';
var release = "".concat(process.env.EEVEE_ID || 'eevee', ":").concat(process.env.RAZZLE_RELEASE);
var kEnv = process.env.KUBE_ENV || 'production';
var isServer = typeof window === 'undefined';
var isDev = env === 'development';
var isProd = env === 'production';
var isCi = process.env.CI && process.env.CI !== 'false';
var defaultCacheControl = 'private, no-store';
var defaultSurrogateControl = 'no-store';
var environment = env;
var cacheControl = process.env.CACHE_CONTROL || defaultCacheControl;
var assetsCacheControl = process.env.ASSETS_CACHE_CONTROL || defaultCacheControl;
var iconsCacheControl = process.env.ICONS_CACHE_CONTROL || defaultCacheControl;
var statusCacheControl = process.env.STATUS_CACHE_CONTROL || defaultCacheControl;
var surrogateControl = process.env.SURROGATE_CONTROL || defaultSurrogateControl;
var assetsSurrogateControl = process.env.ASSETS_SURROGATE_CONTROL || defaultSurrogateControl;
var iconsSurrogateControl = process.env.ICONS_SURROGATE_CONTROL || defaultSurrogateControl;
var statusSurrogateControl = process.env.STATUS_SURROGATE_CONTROL || defaultSurrogateControl;
var surrogateKey = process.env.SURROGATE_KEY || 'content';
var assetsSurrogateKey = process.env.ASSETS_SURROGATE_KEY || 'assets';
var iconsSurrogateKey = process.env.ICONS_SURROGATE_KEY || 'assets icons';
var elasticSearchHost = process.env.ELASTIC_SEARCH_HOST;
var isElasticSearchEnabled = elasticSearchHost && elasticSearchHost.length > 0;
var forceHydration = process.env.RAZZLE_FORCE_HYDRATION === 'true' ? true : process.env.RAZZLE_FORCE_HYDRATION === 'false' ? false : isDev;
var debugHydration = process.env.RAZZLE_DEBUG_HYDRATION === 'true';
var indexPages = process.env.RAZZLE_INDEX_PAGES !== 'false';

export { assetsCacheControl, assetsSurrogateControl, assetsSurrogateKey, cacheControl, debugHydration, env as default, elasticSearchHost, environment, forceHydration, iconsCacheControl, iconsSurrogateControl, iconsSurrogateKey, indexPages, isCi, isDev, isElasticSearchEnabled, isProd, isServer, kEnv, release, statusCacheControl, statusSurrogateControl, surrogateControl, surrogateKey };
